export default "__VITE_ASSET__14340ab2__"